import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLoyaltyCard, getLoyaltyUserCard } from '../../services/api';

// LoyaltyUserCardOnlyPrint.jsx - QR-only print, filtered by card numbers in the URL
export const fetchPrintOnlyCards = createAsyncThunk(
    'loyaltyPrint/fetchPrintOnlyCards',
    async ({ perPage, page, cardNumbers }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyCard(perPage, page, cardNumbers);
            const data = response.data;
            return {
                cards: data.data || data,
                totalPages: data.last_page,
            };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

// LoyaltyUserCardPrint.jsx - full card print, filtered by card numbers in the URL
export const fetchUserCardsForPrint = createAsyncThunk(
    'loyaltyPrint/fetchUserCardsForPrint',
    async ({ perPage, page, cardNumbers }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyUserCard(perPage, page, cardNumbers);
            const data = response.data;
            return {
                cards: data.data || data,
                totalPages: data.last_page,
            };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

const emptyPrintState = () => ({ cards: [], loading: true, error: '', totalPages: 1 });

const loyaltyPrintSlice = createSlice({
    name: 'loyaltyPrint',
    initialState: {
        printOnly: emptyPrintState(),
        userCardPrint: emptyPrintState(),
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPrintOnlyCards.pending, (state) => {
                state.printOnly.loading = true;
            })
            .addCase(fetchPrintOnlyCards.fulfilled, (state, action) => {
                state.printOnly.cards = action.payload.cards;
                state.printOnly.totalPages = action.payload.totalPages;
                state.printOnly.loading = false;
            })
            .addCase(fetchPrintOnlyCards.rejected, (state, action) => {
                state.printOnly.error = action.payload;
                state.printOnly.loading = false;
            })

            .addCase(fetchUserCardsForPrint.pending, (state) => {
                state.userCardPrint.loading = true;
            })
            .addCase(fetchUserCardsForPrint.fulfilled, (state, action) => {
                state.userCardPrint.cards = action.payload.cards;
                state.userCardPrint.totalPages = action.payload.totalPages;
                state.userCardPrint.loading = false;
            })
            .addCase(fetchUserCardsForPrint.rejected, (state, action) => {
                state.userCardPrint.error = action.payload;
                state.userCardPrint.loading = false;
            });
    },
});

export default loyaltyPrintSlice.reducer;
